import { useRestApiProvider } from "@jugl-web/rest-api";
import { Collapse } from "@jugl-web/ui-components/cross-platform/Collapse";
import { LoadingAnimation } from "@jugl-web/ui-components/cross-platform/content/LoadingAnimation";
import { useAppVariant } from "@jugl-web/utils";
import { FC, useState } from "react";
import { TimeTrackingHistoryProps } from "./types";
import { HistoryHeader } from "./components/HistoryHeader";
import { HistoryList } from "./components/HistoryList";

export const TimeTrackingHistory: FC<TimeTrackingHistoryProps> = ({
  entityId,
  taskId,
  meId,
  onShowAll,
  onEditTimeLog,
  onDeleteTimeLog,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const { tasksApi } = useRestApiProvider();

  const { data: summary, isLoading } = tasksApi.useGetMyTimeLogsSummaryQuery({
    entityId,
    taskId,
  });

  const { isMobile } = useAppVariant();

  const summaryTimeLogs = summary?.logs ?? [];
  const totalDuration = summary?.totalDuration ?? 0;

  if (isMobile) {
    return (
      <div className="flex flex-col gap-3">
        <HistoryHeader
          entityId={entityId}
          meId={meId}
          totalDuration={totalDuration}
          isExpanded={isExpanded}
          onToggleExpanded={() => setIsExpanded(!isExpanded)}
        />
        {isLoading ? (
          <LoadingAnimation size="md" />
        ) : (
          <HistoryList
            timeLogs={summaryTimeLogs}
            onShowAll={onShowAll}
            onEditTimeLog={onEditTimeLog}
            onDeleteTimeLog={onDeleteTimeLog}
          />
        )}
      </div>
    );
  }

  return (
    <div className="px-4 py-2">
      <HistoryHeader
        entityId={entityId}
        meId={meId}
        totalDuration={totalDuration}
        isExpanded={isExpanded}
        onToggleExpanded={() => setIsExpanded(!isExpanded)}
      />
      <Collapse
        isOpen={isExpanded}
        className="jugl__custom-scrollbar max-h-[180px] overflow-y-auto"
      >
        {isLoading ? (
          <LoadingAnimation size="md" />
        ) : (
          <HistoryList
            timeLogs={summaryTimeLogs}
            onEditTimeLog={onEditTimeLog}
            onDeleteTimeLog={onDeleteTimeLog}
            onShowAll={onShowAll}
          />
        )}
      </Collapse>
    </div>
  );
};
